import React from 'react'
import { Box, Typography, Button, Alert } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'

function MembershipError() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const message = searchParams.get('message') || 'Something went wrong while processing your payment.'

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <Box sx={{ maxWidth: 560, width: '100%', textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Payment Failed</Typography>
        <Alert severity="error" sx={{ mb: 3 }}>{message}</Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Your card wasn’t charged. You can retry the payment or choose a different plan.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button variant="contained" onClick={() => navigate('/payment')}>Try Again</Button>
          <Button variant="outlined" onClick={() => navigate('/membership' + window.location.search)}>View Plans</Button>
        </Box>
      </Box>
    </Box>
  )
}

export default MembershipError


